<div class="container-view">
  <app-header-unauthenticated [cta]="'signin'" *ngIf="header === 'login'"> </app-header-unauthenticated>

  <main class="authentication">
    <div class="e11-container e11-mx-auto">
      <router-outlet></router-outlet>
    </div>
  </main>
</div>
